<template>
    <div style="width:100%">

        <v-card class="mx-auto mb-4" width="100%">
            <v-card-text>
                <div class="text-h5">Sev Details: <b>{{ data.incident }}</b>  <v-chip  class="ma-2" color="secondary">{{ data.severity }}</v-chip></div>
            </v-card-text>


            <div class="d-flex justify-center secondary">
                <div class="ma-3">Pager Duty TTR:<b> {{ data.pdTtr }}</b></div>
                <div class="ma-3">Status Hub TTR:<b> {{ data.shTtr }}</b></div>
                <div class="ma-3">PostSev (SME) TTR:<b> {{ data.smeTtr }}</b></div>
                <div class="ma-3">IC TTR:<b> {{ data.icTtr }}</b></div>
            </div>

            <div class="pa-4">

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Title (Name)</v-list-item-title>
                        <v-list-item-subtitle>{{ data.title }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Date</v-list-item-title>
                        <v-list-item-subtitle>{{ data.logged | DateTime }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>PagerDuty No</v-list-item-title>
                        <v-list-item-subtitle>{{ data.pd }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Customer Perspective</v-list-item-title>
                        <v-list-item-subtitle>{{ data.customerPerspective }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Root Cause</v-list-item-title>
                        <v-list-item-subtitle>{{ data.rootCause }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Affected Operator</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip class="ma-1" :key="operator" small v-for="operator in affectedOperatorArray">
                                {{ operator }}
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Team</v-list-item-title>
                        <v-list-item-subtitle>{{ data.assignedTeam }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Impacted (Minutes)</v-list-item-title>
                        <v-list-item-subtitle>
                            <v-chip class="ma-1 primary" small>
                                Bets: {{ data.bets }}
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Registrations: {{ data.reg }}
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Logins: {{ data.login }}
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Banking : {{ data.banking }}
                            </v-chip>

                            <v-chip class="ma-1 primary" small>
                                Other : {{ data.other }}
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Assignee</v-list-item-title>
                        <v-list-item-subtitle>{{ data.assignee }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

            </div>


        </v-card>
    </div>
</template>

<script>

    export default {
        name: 'SevImpact',
        data: function () {
            return {
            }
        },
        components: {

        },
        props: {
            data: {
                default: () => ({
                    affectedOperator: "",
                    affecting: "",
                    assignedTeam: "",
                    assignee: "",
                    banking: 0,
                    bets: 0,
                    comment: "",
                    customerPerspective: "",
                    icTtr: 0,
                    incident: "",
                    logged: "",
                    login: 0,
                    other: 0,
                    otherImpactList: "",
                    pbiNumber: "",
                    pbiStatus: "",
                    pd: "",
                    pdTtr: 0,
                    reg: 0,
                    rootCause: "",
                    severity: "",
                    shTtr: 0,
                    signOff: "",
                    smeTtr: 0,
                    title: ""
                }),
                type: Object
            },
        },
        computed: {
            affectedOperatorArray() {
                if (!this.data.affectedOperator) return [];
                return this.data.affectedOperator.replace("[", "").replace("]", "").replace(/"/g,"").split(',').filter(operator => operator !== "");
            }
        },
        methods: {

        }
    }
</script>
